import { render, staticRenderFns } from "./proprietor.vue?vue&type=template&id=6248b27c&scoped=true"
import script from "./proprietor.vue?vue&type=script&lang=js"
export * from "./proprietor.vue?vue&type=script&lang=js"
import style0 from "./proprietor.vue?vue&type=style&index=0&id=6248b27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6248b27c",
  null
  
)

export default component.exports